export default function getDataForPage(buttonValue, collection) {
  if (buttonValue === 'All') return collection

  if (buttonValue === '#') return collection.filter(institution => /\d/.test(institution.name[0]))

  if (/[A-Za-z]/.test(buttonValue))
    return collection.filter(item => item.name[0].toLowerCase() === buttonValue.toLowerCase())
}
